import { useEffect } from "react"

import { adminSkuSelectedRows, isOpenModalAdminSku, isMerged } from "../@signals"


export default function useAdminSkuToolbar(selectedIDs, setSelectedRows) {

    useEffect(() => {
        if (isMerged.value) {
            setSelectedRows([])
            isMerged.value = false
        }
    }, [isMerged.value])

    const handleToolbar = () => {
        adminSkuSelectedRows.value = selectedIDs
        isOpenModalAdminSku.value = true
    }

    return { handleToolbar }
}